import React, { Component } from 'react';
import styled from 'styled-components';

import { COLORS } from '../../../assets/js/constants';
import { FONTS } from '../../../tokens/fonts';
import Odn from './img/odnoklasnik.svg';
import Vk from './img/vk.svg';

const DEFAULT_SOCIALS = {
    vk: {
        img: Vk,
        background: '#4C6F92',
        link: 'https://vk.com/domru',
    },
    odn: {
        img: Odn,
        background: '#EA7147',
        link: 'https://ok.ru/domru',
    },
};

const List = styled.ul`
    display: flex;
    justify-content: flex-start;
    column-gap: 20px;
    align-items: stretch;
    margin: 0;
    padding-left: 0;
`;

const Item = styled.li`
    display: flex;
    list-style: none;
`;

const Link = styled.a`
    ${FONTS.MediumS};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 39px;
    height: 39px;
    background: ${props => props.bg || COLORS.grey};
    opacity: 0.75;
    transition: 0.25s;
    cursor: pointer;
    border-radius: ${props => props.borderRadius || '4px'};
    &:hover {
        opacity: 1;
        transition: 0.25s;
    }
`;

const IconImage = styled.img`
    max-width: 25px;
    max-height: 25px;
`;

class Social extends Component {
    render() {
        const { socials = DEFAULT_SOCIALS, radius, className } = this.props;
        const types = Object.keys(socials);
        const buttons = types.map(type => (
            {
                ...DEFAULT_SOCIALS[type],
                ...socials[type],
            }
        ));
        return (
            <List className={className}>
                {
                    buttons.map((item, index) => (
                        <Item key={index} >
                            <Link href={item.click ? undefined : item.link} onClick={item.click} bg={item.background} borderRadius={radius} { ...{ target: '_blank', rel: `noopener noreferrer${item.link === 'https://vk.com/domru' ? ' nofollow' : ''}` } } aria-label='social link'>
                                {
                                    item.img && <IconImage src={item.img} alt='social icon' />
                                }
                            </Link>
                        </Item>
                    ))
                }
            </List>
        );
    }
}

export default Social;
